import {
  AudioDeviceInfo,
  Call,
  CommunicationServicesError,
  GroupCallLocator,
  JoinCallOptions,
  DeviceManager,
  DeviceAccess,
  RemoteParticipant,
  VideoDeviceInfo,
  CallAgent,
    CallClient,
  //  CallClientOptions,
  HangUpOptions,
    CallEndReason,
 //   DiagnosticOptions,
  Features
} from '@azure/communication-calling';


//import {
  
//    createStatefulCallClient,
//    //fromFlatCommunicationIdentifier,
//    createAzureCommunicationCallAdapterFromClient

//} from '@azure/communication-react';


import { CommunicationUserKind } from '@azure/communication-common';
import { Dispatch } from 'redux';
import { utils, RecordingApiResponse, RecordingActionResponse } from '../Utils/Utils';
import {
  callAdded,
  callRemoved,
  setCallState,
  setParticipants,
  setCallAgent,
  setServerCallId,
  startRecording /*pauseRecording, resumeRecording,*/,
  stopRecording,
  resetRecordingStatus,
  recordingError
} from './actions/calls';
import { setMic, setShareScreen } from './actions/controls';
import {
  setAudioDeviceInfo,
  setAudioDeviceList,
  setCameraPermission,
  setMicrophonePermission,
  setVideoDeviceInfo,
  setVideoDeviceList,
  setDeviceManager
} from './actions/devices';
import { addScreenShareStream, removeScreenShareStream } from './actions/streams';
import { State } from './reducers';
import { setLogLevel } from '@azure/logger';
import RemoteStreamSelector from './RemoteStreamSelector';
import { Constants } from './constants';
import { setUserId } from './actions/sdk';
import { CommunicationUserToken } from '@azure/communication-identity';
import { AzureCommunicationTokenCredential } from '@azure/communication-common';
import { ParticipantInfo, ParticipantModel } from '../Utils/participantInfo';
import { BackgroundBlurEffect, BackgroundReplacementEffect } from '@azure/communication-calling-effects';

let videoEffectsFeatureApi: any;
export const setMicrophone = (mic: boolean) => {
  return async (dispatch: Dispatch, getState: () => State): Promise<void> => {
    const state = getState();

    if (state === undefined || state.calls.call === undefined) {
        console.error('state or state.controls.mic is null');
        console.log('COGBEE :: state or state.controls.mic is null');
      return;
    }

    try {
      if (!state.controls.mic) {
        await state.calls.call.unmute();
      } else {
        await state.calls.call.mute();
      }

      dispatch(setMic(mic));
    } catch (e) {
      console.error(e);
    }
  };
};

export const setShareUnshareScreen = (shareScreen: boolean) => {
  return async (dispatch: Dispatch, getState: () => State): Promise<void> => {
    const state = getState();

    if (state === undefined || state.calls.call === undefined) {
      console.error('state or state.controls.shareScreen is null');
      return;
    }

    try {
      if (!state.controls.shareScreen) {
        await state.calls.call.startScreenSharing();
      } else {
        await state.calls.call.stopScreenSharing();
      }

      dispatch(setShareScreen(shareScreen));
    } catch (e) {
      console.error(e);
    }
  };
};

const subscribeToParticipant = (participant: RemoteParticipant, call: Call, dispatch: Dispatch): void => {
  const remoteStreamSelector = RemoteStreamSelector.getInstance(Constants.DOMINANT_PARTICIPANTS_COUNT, dispatch);

    console.log("COGBEE :: subscribeToParticipant");
  participant.on('stateChanged', () => {
    remoteStreamSelector.participantStateChanged(
      utils.getId(participant.identifier),
      participant.displayName ?? '',
      participant.state,
      !participant.isMuted,
        participant.videoStreams[0].isAvailable
        
    );
    dispatch(setParticipants([...call.remoteParticipants.values()]));
  });

  participant.on('isMutedChanged', () => {
    remoteStreamSelector.participantAudioChanged(utils.getId(participant.identifier), !participant.isMuted);
  });

  participant.on('isSpeakingChanged', () => {
    dispatch(setParticipants([...call.remoteParticipants.values()]));
  });

  participant.on('videoStreamsUpdated', (e): void => {
    e.added.forEach((addedStream) => {
      if (addedStream.mediaStreamType === 'ScreenSharing') {
        addedStream.on('isAvailableChanged', () => {
          if (addedStream.isAvailable) {
            dispatch(addScreenShareStream(addedStream, participant));
          } else {
            dispatch(removeScreenShareStream(addedStream, participant));
          }
        });

        if (addedStream.isAvailable) {
          dispatch(addScreenShareStream(addedStream, participant));
        }
      } else if (addedStream.mediaStreamType === 'Video') {
        addedStream.on('isAvailableChanged', () => {
          remoteStreamSelector.participantVideoChanged(utils.getId(participant.identifier), addedStream.isAvailable);
        });
      }
    });
    dispatch(setParticipants([...call.remoteParticipants.values()]));
  });
};

const updateAudioDevices = async (
  deviceManager: DeviceManager,
  dispatch: Dispatch,
  getState: () => State
): Promise<void> => {
  const microphoneList: AudioDeviceInfo[] = await deviceManager.getMicrophones();
  dispatch(setAudioDeviceList(microphoneList));

  const state = getState();
  if (state.devices.audioDeviceInfo === undefined && microphoneList.length > 0) {
    dispatch(setAudioDeviceInfo(microphoneList[0]));
    deviceManager.selectMicrophone(microphoneList[0]);
  } else if (
    state.devices.audioDeviceInfo &&
    !utils.isSelectedAudioDeviceInList(state.devices.audioDeviceInfo, microphoneList)
  ) {
    deviceManager.selectMicrophone(state.devices.audioDeviceInfo);
  }
};

const updateVideoDevices = async (
  deviceManager: DeviceManager,
  dispatch: Dispatch,
  getState: () => State
): Promise<void> => {
  const cameraList: VideoDeviceInfo[] = await deviceManager.getCameras();
  dispatch(setVideoDeviceList(cameraList));

  const state = getState();
  if (state.devices.videoDeviceInfo === undefined) {
    dispatch(setVideoDeviceInfo(cameraList[0]));
  } else if (
    state.devices.videoDeviceInfo &&
    !utils.isSelectedVideoDeviceInList(state.devices.videoDeviceInfo, cameraList)
  ) {
    dispatch(setVideoDeviceInfo(state.devices.videoDeviceInfo));
  }
};

const subscribeToDeviceManager = async (
  deviceManager: DeviceManager,
  dispatch: Dispatch,
  getState: () => State
): Promise<void> => {
  // listen for any new events
  deviceManager.on('videoDevicesUpdated', async () => {
    updateVideoDevices(deviceManager, dispatch, getState);
  });

  deviceManager.on('audioDevicesUpdated', async () => {
    updateAudioDevices(deviceManager, dispatch, getState);
  });

  deviceManager.askDevicePermission({ audio: true, video: true }).then((e: DeviceAccess) => {
    if (e.audio !== undefined) {
      if (e.audio) {
        dispatch(setMicrophonePermission('Granted'));

        updateAudioDevices(deviceManager, dispatch, getState);
      } else {
        dispatch(setMicrophonePermission('Denied'));
      }
    }

    if (e.video !== undefined) {
      if (e.video) {
        dispatch(setCameraPermission('Granted'));
        updateVideoDevices(deviceManager, dispatch, getState);
      } else {
        dispatch(setCameraPermission('Denied'));
      }
    }
  });
};

export const updateDevices = () => {
  return async (dispatch: Dispatch, getState: () => State): Promise<void> => {
    const state = getState();
    const deviceManager = state.devices.deviceManager;

    if (deviceManager == null) {
      console.error('no device manager available');
      return;
    }

    const cameraList: VideoDeviceInfo[] = await deviceManager.getCameras();

    dispatch(setVideoDeviceList(cameraList));

    const microphoneList: AudioDeviceInfo[] = await deviceManager.getMicrophones();

    dispatch(setAudioDeviceList(microphoneList));
  };
};

export const resetRecordingState = () => {
  return async (dispatch: Dispatch, getState: () => State): Promise<void> => {
    const state = getState();
    if (state.calls) {
      dispatch(resetRecordingStatus());
    } else {
      return;
    }
  };
};



export const startRecord = () => {

    //console.log("#COGBEE# :: StartRecord SideEffects");
    
  return async (dispatch: Dispatch, getState: () => State): Promise<void> => {
    const state = getState();
      if (state.calls !== undefined && state.calls.serverCallId) {
        dispatch(startRecording(Constants.STARTING, ''));
          console.log("#COGBEE# :: startRecording SideEffects");


        const response: RecordingApiResponse = await utils.startRecording(state.calls.serverCallId);
          await response;
       // console.log("#COGBEE# :: response.message SideEffects :: " + response.message);
        //console.log("#COGBEE# :: response.recordingId SideEffects :: " + response.recordingId);

        if (response && !response.message && response.recordingId !== '') {
           // console.log("#COGBEE# :: Dispatch Start SideEffects :: " + response.recordingId);
            dispatch(startRecording(response.recordingId.toString(), Constants.STARTED));
            //console.log("#COGBEE# :: Dispatch End SideEffects :: " + response.recordingId);
            

      } else {
        dispatch(recordingError(response.message));
        console.error(response.message);
      }
    } else {
      console.error('serverCallId not available');
      return;
    }
  };
};

//Use this code if you have to implement pause/resume recording
/*export const pauseRecord = () => {
    return async (dispatch: Dispatch, getState: () => State): Promise<void> => {
        let state = getState();
        if (state.calls !== undefined && state.calls.serverCallId && state.calls.recordingId !== undefined) {
            const response: RecordingActionResponse = await utils.pauseRecording(state.calls.serverCallId, state.calls.recordingId);
            if (response && !response.message) {
                dispatch(pauseRecording(Constants.PAUSED));
            } else {
                console.error(response.message);
            }
        }
        else
            return;
    }
};*/

//Use this code if you have to implement pause/resume recording
/*export const resumeRecord = () => {
    return async (dispatch: Dispatch, getState: () => State): Promise<void> => {
        let state = getState();
        if (state.calls !== undefined && state.calls.serverCallId && state.calls.recordingId !== undefined) {
            const response: RecordingActionResponse = await utils.resumeRecording(state.calls.serverCallId, state.calls.recordingId);
            if (response && !response.message) {
                dispatch(resumeRecording(Constants.RESUMED));
            } else {
                console.error(response.message);
            }
        }
        else
            return;
    }
};*/

export const stopRecord = () => {
  return async (dispatch: Dispatch, getState: () => State): Promise<void> => {
    const state = getState();
    if (state.calls !== undefined && state.calls.serverCallId && state.calls.recordingId !== undefined) {
      const response: RecordingActionResponse = await utils.stopRecording(
        state.calls.serverCallId,
        state.calls.recordingId
      );
      if (response && !response.message) {
        dispatch(stopRecording(Constants.STOPPED));
      } else {
        console.error(response.message);
      }
    } else return;
  };
};

export const registerToCallAgent = (
  userId: string,
  callAgent: CallAgent,
  callEndedHandler: (reason: CallEndReason) => void
) => {
  return async (dispatch: Dispatch, getState: () => State): Promise<void> => {
    setLogLevel('verbose');

    setUserId(userId);
    setCallAgent(callAgent);

    callAgent.on('callsUpdated', (e: { added: Call[]; removed: Call[] }): void => {
      e.added.forEach((addedCall) => {
        console.log(`Call added : Call Id = ${addedCall.id}`);

        const state = getState();
        if (state.calls.call && addedCall.direction === 'Incoming') {
          addedCall.hangUp();
          return;
        }

        dispatch(callAdded(addedCall));

          const callRecordingApi = addedCall.feature(Features.Recording);
        const isRecordingActiveChangedHandler = (): void => {
          if (callRecordingApi.isRecordingActive) {
            if (getState().calls.recordingId === '') {
              dispatch(startRecording('', Constants.STARTED));
            }
          } else if (!callRecordingApi.isRecordingActive) {
            if (getState().calls.recordingId === '' || getState().calls.recordingStatus === Constants.STARTED) {
              dispatch(stopRecording(Constants.STOPPED));
            }
          }
        };
        callRecordingApi.on('isRecordingActiveChanged', isRecordingActiveChangedHandler);

        addedCall.on('stateChanged', (): void => {
          dispatch(setCallState(addedCall.state));

          if (addedCall.state === 'Connected') {
            addedCall.info
              .getServerCallId()
              .then((result) => {
                console.log('Conversation URL is - ' + result);
                dispatch(setServerCallId(result));
              })
              .catch((err) => {
                console.log(err);
              });
          }
        });

        dispatch(setCallState(addedCall.state));

        addedCall.on('isScreenSharingOnChanged', (): void => {
          dispatch(setShareScreen(addedCall.isScreenSharingOn));
        });

        dispatch(setShareScreen(addedCall.isScreenSharingOn));

        // if remote participants have changed, subscribe to the added remote participants
        addedCall.on('remoteParticipantsUpdated', (ev): void => {
          // for each of the added remote participants, subscribe to events and then just update as well in case the update has already happened
          const state = getState();
          ev.added.forEach((addedRemoteParticipant) => {
            subscribeToParticipant(addedRemoteParticipant, addedCall, dispatch);
            dispatch(setParticipants([...state.calls.remoteParticipants, addedRemoteParticipant]));
          });

          // We don't use the actual value we are just going to reset the remoteParticipants based on the call
          if (ev.removed.length > 0) {
            dispatch(setParticipants([...addedCall.remoteParticipants.values()]));
          }
        });

        dispatch(setParticipants([...state.calls.remoteParticipants]));
      });
      e.removed.forEach((removedCall) => {
        const state = getState();
        if (state.calls.call && state.calls.call === removedCall) {
          dispatch(callRemoved(removedCall, state.calls.group));
          if (removedCall.callEndReason && removedCall.callEndReason.code !== 0) {
            removedCall.callEndReason && callEndedHandler(removedCall.callEndReason);
          }
        }
      });
    });
  };
};

//let _CallClientOptions: CallClientOptions;
//let _DiagnosticOptions: DiagnosticOptions;

//_DiagnosticOptions = {
//    appName: "azure calling"
//};
//_DiagnosticOptions = {
//    appName: "azure calling"
//};

//_CallClientOptions = {
//    diagnostics: _DiagnosticOptions
//}
//_CallClientOptions = {
//    diagnostics: _DiagnosticOptions
//}
export type TokenResponse = {
    tokenCredential: AzureCommunicationTokenCredential;
    userId: string;
};

let _tokenCredential: AzureCommunicationTokenCredential;
let _userId: string;

export const getToken= async(): Promise<TokenResponse> => {
    const tokenResponse: CommunicationUserToken = await utils.getTokenForUser();
    const userToken = tokenResponse.token;
    const userId = tokenResponse.user.communicationUserId;

    const tokenCredential = new AzureCommunicationTokenCredential({
        tokenRefresher: (): Promise<string> => {
            return utils.getRefreshedTokenForUser(userId);
        },
        refreshProactively: true,
        token: userToken
    });

    _tokenCredential = tokenCredential;
    _tokenCredential = tokenCredential;
    console.log(_tokenCredential);
    console.log(_userId);
    _userId = userId;
    _userId = userId;

    console.log(tokenCredential);

    return {
        tokenCredential,
        userId
    };
};

export const initCallClient = (unsupportedStateHandler: () => void) => {
    return async (dispatch: Dispatch, getState: () => State): Promise<void> => {
        
        let callClient;

    // check if chrome on ios OR firefox browser
        if (utils.isOnIphoneAndNotSafari() || utils.isUnsupportedBrowser()) {

            console.log("COGBEE :: if unsupportedStateHandler");
      unsupportedStateHandler();
      return;
    }

    try {
      setLogLevel('verbose');
        //const callClient_ = new CallClient();
        //console.log(callClient_);

        callClient = new CallClient();
        console.log(callClient);
        const modelone: ParticipantInfo = ParticipantModel();
        const { tokenCredential, userId } = await getToken();
        _callAgent = await callClient.createCallAgent(tokenCredential, { displayName: modelone.userName + "_" + modelone.role });
        tokenUserId = userId;
       // const callAgent_1: CallAgent = await callClient.createCallAgent(_tokenCredential, { displayName: _userId });
       // console.log(callAgent_1);
    } catch (e) {
        console.log("COGBEE :: Catch");
        console.log(e);
      unsupportedStateHandler();
      return;
    }

    if (!callClient) {
      return;
    }

    const deviceManager: DeviceManager = await callClient.getDeviceManager();

    dispatch(setDeviceManager(deviceManager));
    subscribeToDeviceManager(deviceManager, dispatch, getState);
  };
};

// what does the forEveryone parameter really mean?
export const endCall = async (call: Call, options: HangUpOptions): Promise<void> => {
  //  alert("COGBEE :: end call from sideeffects");
  await call.hangUp(options).catch((e: CommunicationServicesError) => console.error(e));
};

export const joinGroup = async (
  callAgent: CallAgent,
  context: GroupCallLocator,
  callOptions: JoinCallOptions
): Promise<void> => {
  try {
    await callAgent.join(context, callOptions);
  } catch (e) {
    console.log('Failed to join a call', e);
    return;
  }
};

export const addParticipant = async (call: Call, user: CommunicationUserKind): Promise<void> => {
  
  await call.addParticipant(user);
};

export const removeParticipant = async (call: Call, user: CommunicationUserKind): Promise<void> => {

    alert("COGBEE :: removeParticipant from sideeffects");

  await call.removeParticipant(user).catch((e: CommunicationServicesError) => console.error(e));
};

export const blurEffectStart = async () => {
    try {
        if (_localVideoStream != undefined) {
             videoEffectsFeatureApi = _localVideoStream.feature(Features.VideoEffects);

            const backgroundBlurEffect = new BackgroundBlurEffect();
            const backgroundBlurSupported = await backgroundBlurEffect.isSupported();
            if (backgroundBlurSupported) {
                // Use the video effects feature api we created to start/stop effects
                await videoEffectsFeatureApi.startEffects(backgroundBlurEffect);
            }
        }

    } catch (error) {
        console.error(error);
    }
}

export const blurEffectStop = async () => {
    try {
        if (videoEffectsFeatureApi != undefined) {
            await videoEffectsFeatureApi.stopEffects();
        }

    } catch (error) {
        console.error(error);
    }
}

//export declare interface Call extends CallCommon {
//}

export { subscribeToDeviceManager, updateAudioDevices }